export default [
  {id: 1, codigo: 'APICULTURA', label: 'Apicultura', showTipo: true},
  {id: 2, codigo: 'AVICULTURA', label: 'Avicultura', showTipo: true},
  {id: 3, codigo: 'BOVINOCULTURA', label: 'Bovinocultura', showTipo: true},
  {id: 4, codigo: 'CUNICULTURA', label: 'Cunicultura', showTipo: true},
  {id: 5, codigo: 'FLORICULTURA', label: 'Floricultura', showTipo: true},
  {id: 6, codigo: 'FRUTICULTURA', label: 'Fruticultura', showTipo: true},
  {id: 7, codigo: 'OLERICULTURA', label: 'Olericultura', showTipo: true},
  {id: 8, codigo: 'PSCICULTURA', label: 'Pscicultura', showTipo: false},
  {id: 9, codigo: 'RANICULTURA', label: 'Ranicultura', showTipo: false},
  {id: 10, codigo: 'SILVICULTURA', label: 'Silvicultura', showTipo: false},
  {id: 11, codigo: 'SUINOCULTURA', label: 'Suinocultura', showTipo: false},
  {id: 12, codigo: 'OUTROS', label: 'Outros', showTipo: true}
]



// WEBPACK FOOTER //
// ./src/utils/tipoOutrasAtividades.js